var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneSharp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.183 14c-1.62 0-3.224-.35-4.812-1.05-1.587-.7-3.03-1.698-4.327-2.994C2.748 8.659 1.75 7.22 1.05 5.639.35 4.057 0 2.45 0 .817V0h4.589l.72 3.908-2.217 2.236a12.023 12.023 0 002.08 2.703c.376.376.788.736 1.235 1.08.448.344.93.664 1.449.962l2.255-2.256L14 9.431V14h-.817z",
    fill: "currentColor"
  })));
}

export default SvgPhoneSharp;